export type { ContactCardProps } from "./contact-card";
export { ContactCard } from "./contact-card";
